export const READ_MOSAIC_ROLE_KEY = 'MosaicRead';
export const ASK_AI_ADMIN_ROLE_KEY = 'AskAIAdmin';
export const ADMIN_ROLE_KEY = 'Admin';

export const accessMosaicRoles = [READ_MOSAIC_ROLE_KEY, ASK_AI_ADMIN_ROLE_KEY, ADMIN_ROLE_KEY];
